import HintIcon from '@images/icons/hint_select_role_icon.svg?react'
import { tr, useMatchMedia } from 'mmfintech-commons'
import ReactTooltip from 'react-tooltip'

import './TransactionApprovalMatrixTooltip.scss'

const preparedToolTip = () => `
 <div>
   <div style="font-size: 16px; margin-bottom: 16px;">
     ${tr('FRONTEND.TRANSACTIONS_MATRIX_DETAILS.TOOLTIP.TITLE', 'Up to 5 approval levels supported.')}
   </div>
   <ul style="list-style-type: disc; padding-left: 20px; margin: 0;">
     <li style="margin-bottom: 12px;">
       ${tr(
         'FRONTEND.TRANSACTIONS_MATRIX_DETAILS.TOOLTIP.LINE1',
         'Multiple approvers at the same level are allowed—approval from any one is sufficient.'
       )}
     </li>
     <li style="margin-bottom: 12px;">
       ${tr('FRONTEND.TRANSACTIONS_MATRIX_DETAILS.TOOLTIP.LINE2', 'The final approver sends the transaction.')}
     </li>
     <li>
       ${tr(
         'FRONTEND.TRANSACTIONS_MATRIX_DETAILS.TOOLTIP.LINE3',
         "If a transaction fits within a level's threshold, it stops there."
       )}
     </li>
   </ul>
 </div>
`

function TransactionApprovalMatrixTooltip() {
  const isMobile = useMatchMedia({ breakpoint: 768, prefix: 'max' })

  return (
    <>
      <span
        className='transaction-approval-matrix-tooltip'
        data-for='transaction-approval-matrix-tooltip'
        data-tip={preparedToolTip()}
      >
        <HintIcon />
      </span>
      <ReactTooltip
        id='transaction-approval-matrix-tooltip'
        place={isMobile ? 'right' : 'bottom'}
        html
        type='dark'
        arrowColor='transparent'
        className='transaction-approval-matrix-tooltip'
        padding={isMobile ? '12px' : '24px'}
      />
    </>
  )
}

export default TransactionApprovalMatrixTooltip
